<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card tile>
          <v-card-title>{{
            $t("common." + (edition_mode ? "edit" : "add"))
          }}</v-card-title>
          <v-divider />
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <UserPicker
                required
                v-model="formModel.user"
                :label="$t('user.select-pef')"
              />
              <v-autocomplete
                v-model="formModel.type"
                :items="types"
                dense
                chips
                item-text="value"
                item-value="name"
                small-chips
                :label="$tc('training.types.title', 1)"
              ></v-autocomplete>
              <v-autocomplete
                v-model="formModel.status"
                :items="status"
                dense
                chips
                item-text="value"
                item-value="name"
                small-chips
                :label="$tc('training.status.title', 1)"
              ></v-autocomplete>
              <v-textarea
                v-model="formModel.comment"
                :label="$tc('common.comment', 1)"
                required
              />
            </v-form>
          </v-card-text>
          <v-divider class="mt-5"></v-divider>
          <v-card-actions>
            <v-btn text @click="$router.go(-1)">{{
              $t("common.cancel")
            }}</v-btn>
            <v-spacer />
            <v-btn tile color="primary" :loading="loading" @click="_submit">{{
              $t("common.save")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ROLES } from "@/utils/config"
import { mapActions } from "vuex"
import { USER_ME_REQUEST } from "@/store/actions/user"
import { ADD, UPDATE, FETCH_ONE } from "@/store/action-types"
import FormMixin from "@/mixins/FormMixin"
import UserPicker from "@/components/form/UserPicker"

export default {
  name: "TrainingForm",
  components: { UserPicker },
  mixins: [FormMixin],
  computed: {
    current_user() {
      return this.$store.state.user.profile
    },
    types() {
      let trans = this.$t("training.types")
      let result = []
      for (let k in trans) {
        if (k !== "title") {
          result.push({ name: k, value: trans[k] })
        }
      }
      return result
    },
    status() {
      let trans = this.$t("training.status")
      let result = []
      let enableStatus = []
      if (!this.formModel.id) {
        enableStatus = ["started"]
      } else {
        if (["PEF", "ASPIRANT"].includes(this.current_user.role)) {
          enableStatus = ["started", "done"]
        } else if (["COACH", "CHIEF"].includes(this.current_user.role)) {
          enableStatus = ["started", "done", "seen_by_coach"]
        } else if (
          ["MENTOR", "ADMIN", "SUPERADMIN"].includes(this.current_user.role)
        ) {
          enableStatus = ["started", "done", "seen_by_coach", "seen_by_mentor"]
        }
      }
      enableStatus.push(this.initialStatus)

      for (let k in trans) {
        if (k !== "title") {
          result.push({
            name: k,
            value: trans[k],
            disabled: !enableStatus.includes(k),
          })
        }
      }
      return result
    },
    required_rule() {
      return [(v) => !!v || this.$t("errors.field_required")]
    },
  },
  data() {
    return {
      formModel: {
        user: {},
      },
      initialStatus: "",
      valid: true,
    }
  },
  async mounted() {
    if (this.current_user == null) {
      await this.USER_ME_REQUEST()
    }
    if (!this.formModel.id) {
      this.formModel.status = "started"
    }
    if (this.$route.params.training_id) {
      this.edition_mode = true
      let self = this
      await this.FETCH_ONE(this.$route.params.training_id)
        .then((data) => {
          self.$set(self, "formModel", data)
          this.initialStatus = data.status
        })
        .finally(() => {
          self.loading = false
        })
    } else {
      this.formModel.user = { id: Number(this.$route.params.user_id) }
    }
  },

  methods: {
    ...mapActions("user", [USER_ME_REQUEST, UPDATE]),
    ...mapActions("training", [FETCH_ONE, UPDATE, ADD]),

    _submit() {
      this.submit(
        ["user", "id", "type", "comment", "status"],
        (data) => "/users/" + data.user.id + "?tab=training",
        "user"
      )
    },

    get_above_roles() {
      if (this.current_user.role) {
        let current_role = ROLES[this.current_user.role.toUpperCase()]
        return Object.keys(ROLES).filter((value) => ROLES[value] > current_role)
      }
      return []
    },
  },
}
</script>
